import { createAction } from '../util';

// TODO: This will need to be changed to an async action eventually
export const setCurrentCart = createAction('SET_CURRENT_CART');

export const clearCurrentCart = createAction('CLEAR_CURRENT_CART');

export const sortAndFilterCart = createAction('SORT_AND_FILTER_CART');

export const setCartAttribute = createAction('SET_CART_ATTRIBUTE');

export const setSizeQuantity = createAction('SET_SIZE_QUANTITY');

export const setUnitAllotmentId = createAction('SET_UNIT_ALLOTMENT_ID');

export const setPaymentMethod = createAction('SET_PAYMENT_TYPE');

export const setCustomerRequestDate = createAction('SET_CUSTOMER_REQUEST_DATE');

export const setCurrentCartTotals = createAction('CALCULATE_CART_TOTALS');

export const setCurrentCartHeader = createAction('SET_CART_HEADER');

export const setProductGroupAddress = createAction('SET_PRODUCT_GROUP_ADDRESS');

export const setProductAddress = createAction('SET_PRODUCT_ADDRESS');

export const updateCartProductPurchasables = createAction('UPDATE_CART_PRODUCT_PURCHASABLES');

export const updateCartEtag = createAction('UPDATE_CART_ETAG');

export const validateCart = createAction('VALIDATE_CART');

export const assignCartProductGroups = createAction('ASSIGN_CART_PRODUCT_GROUPS');

export const clearPendingSave = createAction('CLEAR_PENDING_SAVE');
